import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const CategoryViewWrapper = styled.div`
  width: 100%;
  padding-bottom: 4rem;
`;

export const GridWrapper = styled.div`
  --columns: 1;
  display: grid;
  grid-template-columns: repeat(var(--columns), 1fr);
  gap: 1rem;

  ${media.md`
    --columns: 3;
  `}
`;

export const StyledPageDescription = styled.div`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  font-family: ${({ theme }) => theme.bodyFont};
  line-height: 23px;
`;

export const StyledPageTitleContainer = styled.div`
  margin-top: ${({ theme }) => theme.spaces.space6};
`;
